import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {currentResource, labels} from '../../../../../util/utils';
import env from '../../../../../util/env';
import TextLink from '../../../../Common/BaseComponentWrappers/MotifTextLink';
import {useIsDrawerMode} from '../../../../../util/Ares/customHooks';
import {useEngagementId} from '../../../../../util/customHooks';

function ProjectValidation(props) {
	const engagementId = useEngagementId();
	const isDrawerMode = useIsDrawerMode();
	let herculesUrl = env.getURL('hercules_web') + '/connections?engagementid=' + engagementId;
	let helixBaseUrl = env.getURL('Helix_Analyzer_Base_Url');
	return (
		<>
			<HelixProjectsList>
				<li>
					<section className="project-name">
						<span className="project-namelbl" title={props.project.projectName}>
							{props.project.projectName}
						</span>
					</section>

					{props.errorCode === undefined ? (
						<section className="validation-container" />
					) : (
						<section className="validation-container">
							{props.errorCode === 801 ? (
								<span className="validation-msg1">
									{' '}
									{currentResource.HelixProjectValidationErrors[props.errorCode]}
								</span>
							) : props.errorCode === 800 ? (
								<section className="validation-msg2">
									<span className="validation-msg2txt">
										{currentResource.HelixProjectValidationErrors[props.errorCode]}
									</span>
									<TextLink variant="alt" href={helixBaseUrl}>
										{labels.eyHelix}
									</TextLink>
									<span className="login-inst"> {labels.loginInstructions}</span>
								</section>
							) : (
								<section>{currentResource.HelixProjectValidationErrors[929]} </section>
							)}
						</section>
					)}
					{!isDrawerMode && (
						<section className="helixprojects-link">
							{
								<TextLink variant="alt" href={herculesUrl} title={labels.eyHelixProjects}>
									{labels.eyHelixProjects}
								</TextLink>
							}
						</section>
					)}
				</li>
			</HelixProjectsList>
		</>
	);
}
export default ProjectValidation;

const HelixProjectsList = styled.ul`
	li {
		.project-name {
			display: inline-block;
			width: 25%;
			vertical-align: top;
			.project-namelbl {
				display: block;
				color: var(--neutrals-900);
				font-size: var(--px-16);
				font-weight: 400;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				max-width: 97%;
			}
		}
		.validation-container {
			display: inline-block;
			width: 59%;
			.validation-msg1 {
				display: block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				max-width: 97%;
				font-size: var(--px-14);
				font-weight: 300;
			}
			.validation-msg2 {
				display: inline-block;
				width: 98%;
				color: var(--neutrals-700);
				.validation-msg2txt {
					display: inline-block;
					font-size: var(--px-14);
					font-weight: 300;
				}
				.login-inst {
					//display:inline-block;
					font-size: var(--px-14);
					font-weight: 300;
				}
				.motif-text-link {
					display: inline-block;
				}
			}
		}
		.helixprojects-link {
			display: inline-flex;
			width: 16%;
			.motif-text-link {
				display: inline-block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin-left: auto;
			}
		}
	}
`;
